<template>
  <div class="my-toast-content">
    <van-overlay :show="value" @click="hideToast">
      <div
        class="my-toast"
        @click.stop="bindStop"
        :style="{ zIndex: defaultZindex + (options.zIndex + 1 || zIndex) }"
      >
        <img
          class="toast-image"
          ref="toastImage"
          :src="options.image || image"
          alt=""
          v-show="options.image || image || loadedImage"
          @load="bindLoadImage"
          :style="{
            marginTop: options.imageTop || imageTop,
            width: computImage(options.imageWidth),
            height: computImage(options.imageHeight, true)
          }"
        />
        <div class="toast-content">
          <div class="title">{{ options.title || title }}</div>
          <div class="text-content">
            <div
              class="text"
              v-html="options.message || message"
              :style="{ textAlign: options.messageAlign || messageAlign }"
            ></div>
          </div>
          <div
            class="btn-content"
            :class="{
              'btn-limit':
                (options.showCancelButton || showCancelButton) &&
                (options.showConfirmButton || showConfirmButton)
            }"
          >
            <div
              class="btn-item cancel"
              v-if="options.showCancelButton || showCancelButton"
              :style="{
                backgroundColor: options.cancelButtonColor || cancelButtonColor
              }"
              @click="bindCacel"
            >
              {{ options.cancelButtonText || cancelButtonText }}
            </div>
            <div
              class="btn-item confirm"
              v-if="options.showConfirmButton || showConfirmButton"
              :style="{
                backgroundColor:
                  options.confirmButtonColor || confirmButtonColor
              }"
              @click="bindConfirm"
            >
              {{ options.confirmButtonText || confirmButtonText }}
            </div>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>
<script>
export default {
  props: {
    options: {
      type: Object,
      default: () => {
        return {}
      }
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      defaultZindex: 2000,
      zIndex: 1,
      imageTop: '0px',
      image: '',
      title: '',
      width: '78.67vw',
      message: '',
      messageAlign: 'center',
      showConfirmButton: true,
      showCancelButton: false,
      confirmButtonText: '确认',
      confirmButtonColor: '#6236FF',
      cancelButtonText: '取消',
      cancelButtonColor: '#ffffff',
      loadedImage: false, //是否加载完成图片
      toastImage: {
        width: 0,
        height: 0
      }
    }
  },
  methods: {
    computImage(value, isHeight) {
      if (!value) {
        return isHeight ? 'auto' : '100%'
      }
      let res = Math.floor((value / 375) * 10000) / 100 + 'vw'
      return res
    },
    bindClose() {
      this.hideToast()
    },
    //加载图片完成
    bindLoadImage(e) {
      console.log(e)
      let scale = 3 //放大倍率
      let img = this.$refs.toastImage
      let width = img.naturalWidth / scale
      let height = img.naturalHeight / scale
      this.toastImage = {
        width,
        height
      }
    },
    bindStop() {},
    showToast() {
      this.$emit('input', true)
    },
    hideToast() {
      this.$emit('cancel')
      this.$emit('input', false)
    },
    bindConfirm() {
      this.$emit('confirm')
      this.$emit('input', false)
    },
    bindCacel() {
      this.$emit('cancel')
      this.$emit('input', false)
    }
  }
}
</script>
<style scoped lang="scss">
.toast-fixed {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
}
.toast-fade-enter-active {
  animation: 0.3s van-fade-in both ease-out;
}
.my-toast {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%) scale(1);
  width: 295px;
  padding-top: 20px;
  background: #ffffff;
  border-radius: 12px;
  display: flex;
  align-items: stretch;
  flex-direction: column;
  animation: myScale 0.3s ease;
  .toast-image {
    width: 100%;
    height: 70px;
    border-radius: 12px 12px 0px 0px;
    overflow: hidden;
    margin: 0 auto 20px;
  }
  .toast-content {
    padding: 0px 20px 20px;
    box-sizing: border-box;
    .title {
      text-align: center;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.8);
      line-height: 25px;
      margin-bottom: 6px;
    }
    .text-content {
      text-align: center;
    }
    .text {
      display: inline-block;
      text-align: left;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(0, 0, 0, 0.6);
      line-height: 24px;
    }
    .btn-content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 30px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(0, 0, 0, 0.5);
      height: 44px;
      line-height: 44px;
      .btn-item {
        flex: 1;
        height: 100%;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        text-align: center;
        border-radius: 12px;
        border: 1px solid rgba(0, 0, 0, 0.5);
        box-sizing: border-box;
      }
      .confirm {
        background: #6236ff;
        color: #ffffff;
        border: 1px solid #6236ff;
      }
    }
    .btn-limit {
      .btn-item {
        flex: 0 0 122px;
      }
    }
  }
}
@keyframes myScale {
  0% {
    transform: translate(-50%, -50%) scale(0.7);
  }
  100% {
    transform: translate(-50%, -50%) scale(1);
  }
}
</style>
